import { render } from "./ComplementaryProducts.vue?vue&type=template&id=4909969c"
import script from "./ComplementaryProducts.vue?vue&type=script&lang=js"
export * from "./ComplementaryProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__